let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = (load("dO5k0")).then(() => parcelRequire('27czT'));